import api from './api';
import apiRoutes from '../../../api/apiRoutes';

export const fetchProperties = async () => {
  const response = await api.get(apiRoutes.properties.ownerList);
  const data = response.data;
  // Handle paginated response
  return Array.isArray(data) ? data : (data.results || []);
};

export const createProperty = async (payload) => {
  const response = await api.post(apiRoutes.properties.list, payload);
  return response.data;
};

export const updateProperty = async (propertyId, payload) => {
  const response = await api.patch(apiRoutes.properties.ownerDetail(propertyId), payload);
  return response.data;
};

export const deleteProperty = async (propertyId) => {
  const response = await api.delete(apiRoutes.properties.ownerDetail(propertyId));
  return response.data;
};
